import { FormsEntities, BaseState, FormsActionTypes } from '@bimser/common';
import { createSyncAction } from '@bimser/core';
import { RuleEngineEntities } from '@bimser/components/dist/BCRuleManager';
import * as LayoutCreatorEntities from '@bimser/components/dist/BCLayoutCreator/common/entities';
import { List, Map } from 'immutable';
import { put, select } from 'redux-saga/effects';
import { convertActionValue } from '.';
import { getActionValue } from './getActionValue';

export function* runValueAssaignWithSelectionAction(
	action: RuleEngineEntities.IValueAssignActionWithSelection,
	getOldFormData: () => Map<string, LayoutCreatorEntities.LayoutDataItem>,
	windowId: string
) {
	const mainState: BaseState = yield select();
	const defaultCulture = mainState.system.language.items.find(lang => lang.isDefault).culture;
	// Update data for next action
	let oldFormData = yield getOldFormData();

	let changeData: List<FormsEntities.PropertyChangeEventArgs> = List();

	const sourceControlId = action.selectedField.name;
	const sourceValuePath = action.selectedField.propertyName;

	const targetControlId = action.field.name;
	const targetValuePath = action.field.propertyName.split('.');

	const sourceValue = getActionValue(sourceControlId, sourceValuePath, oldFormData);

	const { dataField, value } = convertActionValue(
		action.field,
		sourceValue,
		oldFormData,
		targetValuePath
	);

	const pLoad = FormsEntities.PropertyChangeEventArgsFactoryFromJS({
		dataField,
		handled: false,
		id: targetControlId,
		value
	});

	changeData = changeData.set(changeData.count(), pLoad);

	// Update data for next action
	oldFormData = oldFormData.setIn([targetControlId, 'properties', ...targetValuePath], value);

	const changeTransaction = FormsEntities.PropertyChangeTransactionFactory({
		data: changeData
	});

	const changePropertyAction = createSyncAction(
		FormsActionTypes.CHANGE_PROPERTY,
		FormsEntities.PropertyChangeActionFactory({ data: changeTransaction, windowId })
	);
	yield put(changePropertyAction);
}
